import { checkYearIsSameOrBefore } from './format-date';
import { getOnlyNumbers } from './get-only-numbers';
import { getCountryPhoneMasks, parseCountryPhone, removeSymbolsFromPhoneMask } from './phone-mask';

import { CountryCode, InputMaxLength, InputMinLength, Regex } from 'src/constants';

export const getIsEmailValid = (email: string) => {
  const trimmedEmail = email?.trim() ?? '';
  return trimmedEmail.length <= InputMaxLength.EMAIL && Regex.EMAIL.test(trimmedEmail);
};
export const getIsMessageValid = (value: string, isRequired: boolean) =>
  value?.trim()?.length <= InputMaxLength.TEXT &&
  (isRequired ? value?.trim()?.length >= InputMinLength.MESSAGE : true);
export const getIsPhoneValid = (phone: string) => Regex.PHONE.test(phone.trim());
export const getIsCountryPhoneValid = (phone: string, countryCode: CountryCode) => {
  const regexps = getCountryPhoneMasks(countryCode).map(
    (mask) => new RegExp(`^${removeSymbolsFromPhoneMask(mask).replace(/#/g, '\\d')}$`)
  );
  const phoneNumbers = getOnlyNumbers(parseCountryPhone(phone).phone);
  return regexps.some((regexp) => regexp.test(phoneNumbers));
};
export const getIsTextValid = (value: string) =>
  value?.trim()?.length >= InputMinLength.TEXT && value?.trim()?.length <= InputMaxLength.TEXT;
export const getIsYearValid = (year: string) =>
  !year || (Regex.YEAR.test(year) && checkYearIsSameOrBefore(year));
